import ozButtonNumber from '@/components/filters/oz-button-number/'

export default {
  name: 'oz-modal-footer',

  props: {
    isDisabled: { type: [Boolean], default: false },
  },

  methods: {
    onSearch () {
      this.$emit('filters:search')
    },

    onRemoveFilters () {
      this.$emit('filters:remove')
    },
  },

  components: {
    ozButtonNumber,
  },
}
